import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfterMitigation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .654765,
		d: "M30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0Z",
		fill: "#ECFDF5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 23L24.5 32L31.9375 26L43.625 36M35.125 36H43.625V28",
		stroke: "#047857",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgAfterMitigation;
